import { useCallback, useEffect, useState } from 'react';

import * as shortUrlApi from '@hotjar/webapp/domains/short-link/api';

export type RequestState =
  | {
      status: 'idle';
    }
  | {
      status: 'loading';
    }
  | {
      status: 'error';
      error: Error;
    }
  | {
      status: 'success';
      data: string;
    };

export function useShortUrl(siteId: string, longUrl: string): RequestState {
  const [requestState, setRequestState] = useState<RequestState>({ status: 'idle' });

  const getShortUrl = useCallback(async () => {
    setRequestState({ status: 'loading' });

    try {
      const shortUrl = await shortUrlApi.getShortUrl(siteId, longUrl);
      setRequestState({ status: 'success', data: shortUrl });
    } catch (err) {
      // @ts-expect-error fix catch error type
      setRequestState({ status: 'error', error: err });
    }
  }, [siteId, longUrl]);

  useEffect(() => {
    getShortUrl();
  }, [getShortUrl]);

  return requestState;
}
